const routes = [
  {
    path: '',
    component: () =>
      import(
        '@/views/provider/billingAdjustmentManagement/BillingManagementWrapper.vue'
      ),
    children: [
      {
        path: '/provider/billingAdjustmentManagement',
        name: 'billingAdjustmentManagement',
        component: () =>
          import(
            '@/views/provider/billingAdjustmentManagement/BillingManagement.vue'
          ),
      },
    ],
  },
];

export default routes;
